var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as download from "downloadjs";
import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Dimmer, Divider, Grid, Header, Loader, Message } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import { getWithAuthn } from "../RequestHelpers";
var LabelsModal = /** @class */ (function (_super) {
    __extends(LabelsModal, _super);
    function LabelsModal(props) {
        var _this = _super.call(this, props) || this;
        _this.renderSimpleLabel = function (title, l) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, title),
                copyButton(l),
                React.createElement("pre", null, l.contentLines.join('\n')));
        };
        _this.renderListOfLabels = function (title, l) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, title),
                React.createElement("ul", null, l.map(function (label, index) {
                    return React.createElement("li", { key: index, style: { 'margin': '1.5rem' } },
                        React.createElement("div", null,
                            copyButton(label),
                            React.createElement("pre", null, label.contentLines.join('\n'))),
                        label.extraLines.length > 0 && React.createElement("div", null,
                            "Metadata",
                            React.createElement("ul", null, label.extraLines.map(function (line, lineIndex) {
                                return React.createElement("li", { key: lineIndex }, line);
                            }))));
                })));
        };
        _this.getLabels = function () {
            _this.setState({
                loading: true,
                error: false
            }, function () {
                getWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/labels")
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return Promise.resolve(undefined);
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't send email: " + rej);
                });
            });
        };
        _this.downloadButton = function (resp) {
            var handler = function () {
                var contents = [
                    "Order id: " + _this.props.order.id,
                    "User: " + _this.props.order.user.name + " (" + _this.props.order.user.id + ")",
                    "Shipping country code: " + _this.props.order.shippingAddress.countryCode,
                    '',
                    'v3.0 Probe set samples'
                ]
                    .concat(resp.v3ProbeSetTubeLabels.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines)
                        .concat(['', 'Metadata', ''])
                        .concat(l.extraLines);
                }))
                    .concat(['', '', 'v3.0 Probe sets', ''])
                    .concat(resp.v3ProbeSetBoxLabel.contentLines)
                    .concat(['', '', 'v3.0 Amplifiers', ''])
                    .concat(resp.v3AmplifierBoxLabel.contentLines)
                    .concat(['', '', 'v3.0 Amplifier summary', ''])
                    .concat(resp.v3AmplifierSummary.contentLines)
                    .concat(['', '', 'v3.0 Buffers', ''])
                    .concat(resp.v3BufferVolumeLabel.flatMap(function (l, index) {
                    return l.contentLines
                        .concat(['', 'Metadata', ''])
                        .concat(l.extraLines);
                }))
                    .concat(['', '', 'v3.0 2ºIF Probes', ''])
                    .concat(resp.v3SecondaryIfProbes.contentLines)
                    .concat(['', '', 'v3.0 2ºIF Probe Summary', ''])
                    .concat(resp.v3SecondaryIfProbeSummary.contentLines)
                    .concat(['', '', 'Gold Probe set samples', ''])
                    .concat(resp.goldProbeSetTubeLabels.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines)
                        .concat(['', 'Metadata', ''])
                        .concat(l.extraLines);
                }))
                    .concat(['', '', 'Gold Probe sets', ''])
                    .concat(resp.goldProbeSetBoxLabel.contentLines)
                    .concat(['', '', 'HiFi Encoder', ''])
                    .concat(resp.encoderLabel.contentLines)
                    .concat(['', '', 'HiFi Encoder Summary', ''])
                    .concat(resp.encoderSummaryLabel.contentLines)
                    .concat(['', '', 'Gold Amplifiers', ''])
                    .concat(resp.goldAmplifierBoxLabel.contentLines)
                    .concat(['', '', 'Gold Amplifier summary', ''])
                    .concat(resp.goldAmplifierSummary.contentLines)
                    .concat(['', '', 'Gold/Manual Pro Buffers', ''])
                    .concat(resp.goldBufferVolumeLabel.flatMap(function (l, index) {
                    return l.contentLines
                        .concat(['', 'Metadata', ''])
                        .concat(l.extraLines);
                }))
                    .concat(['', '', 'Gold 2ºIF Probes', ''])
                    .concat(resp.goldSecondaryIfProbes.contentLines)
                    .concat(['', '', 'Good 2ºIF Probe Summary', ''])
                    .concat(resp.goldSecondaryIfProbeSummary.contentLines)
                    .concat(['', '', 'RNA-ISH Probe Sets'])
                    .concat(resp.rnaCishProbeSetBoxLabel.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines);
                }))
                    .concat(['', '', 'RNA-ISH Probe Set Samples'])
                    .concat(resp.rnaCishProbeSetTubeLabels.flatMap(function (l, index) {
                    return ['', "Kit #" + (index + 1), '']
                        .concat(l.contentLines);
                }))
                    .concat(['', '', 'RNA-CISH Protocol', ''])
                    .concat(resp.rnaCishProtocolLabel.contentLines);
                var blob = new Blob([contents.join('\n')], {
                    type: 'text/plain',
                    endings: 'transparent'
                });
                download(blob, "Order " + _this.props.order.id + " labels.txt", 'text/plain');
            };
            return React.createElement(Button, { icon: 'download', label: "Download all", labelPosition: 'left', onClick: handler });
        };
        _this.state = {
            loading: false,
            error: false,
        };
        return _this;
    }
    LabelsModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.response &&
                React.createElement(React.Fragment, null,
                    React.createElement(Divider, null),
                    React.createElement("p", null,
                        "Order id: ",
                        this.props.order.id),
                    React.createElement("p", null,
                        "User: ",
                        React.createElement(Link, { to: AppPaths.ADMIN_USER_BASE + "/" + encodeURIComponent(this.props.order.user.id) },
                            this.props.order.user.name,
                            " (",
                            this.props.order.user.id,
                            ")")),
                    React.createElement("p", null,
                        "Shipping country code: ",
                        this.props.order.shippingAddress.countryCode),
                    React.createElement("p", { style: { marginTop: '1rem' } }, this.downloadButton(this.state.response)),
                    React.createElement(Grid, { columns: 2 },
                        React.createElement(Grid.Column, null,
                            this.renderListOfLabels('v3.0 Probe samples', this.state.response.v3ProbeSetTubeLabels),
                            this.renderSimpleLabel('v3.0 Probe sets', this.state.response.v3ProbeSetBoxLabel),
                            this.renderSimpleLabel('v3.0 Amplifiers', this.state.response.v3AmplifierBoxLabel),
                            this.renderSimpleLabel('v3.0 Amplifier Summary', this.state.response.v3AmplifierSummary),
                            this.renderListOfLabels('v3.0 Buffers', this.state.response.v3BufferVolumeLabel),
                            this.renderSimpleLabel('v3.0 2ºIF Probes', this.state.response.v3SecondaryIfProbes),
                            this.renderSimpleLabel('v3.0 2ºIF Probe Summary', this.state.response.v3SecondaryIfProbeSummary),
                            React.createElement(Header, null, "RNA-ISH Probe Samples"),
                            React.createElement("ul", null, this.state.response.rnaCishProbeSetTubeLabels.map(function (label, index) {
                                return React.createElement("li", { key: index, style: { 'margin': '1.5rem' } },
                                    React.createElement("div", null,
                                        copyButton(label),
                                        React.createElement("pre", null, label.contentLines.join('\n'))));
                            })),
                            React.createElement(Header, null, "RNA-ISH Probes"),
                            React.createElement("ul", null, this.state.response.rnaCishProbeSetBoxLabel.map(function (label, index) {
                                return React.createElement("li", { key: index, style: { 'margin': '1.5rem' } },
                                    React.createElement("div", null,
                                        copyButton(label),
                                        React.createElement("pre", null, label.contentLines.join('\n'))));
                            })),
                            this.renderSimpleLabel('ISH Platform', this.state.response.rnaCishProtocolLabel)),
                        React.createElement(Grid.Column, null,
                            this.renderListOfLabels('Gold Probe samples', this.state.response.goldProbeSetTubeLabels),
                            this.renderSimpleLabel('Gold Probe sets', this.state.response.goldProbeSetBoxLabel),
                            this.renderSimpleLabel('HiFi Encoder', this.state.response.encoderLabel),
                            this.renderSimpleLabel('HiFi Encoder Summary', this.state.response.encoderSummaryLabel),
                            this.renderSimpleLabel('Gold Amplifiers', this.state.response.goldAmplifierBoxLabel),
                            this.renderSimpleLabel('Gold Amplifier Summary', this.state.response.goldAmplifierSummary),
                            this.renderListOfLabels('Gold/Manual Pro Buffers', this.state.response.goldBufferVolumeLabel),
                            this.renderSimpleLabel('Gold 2ºIF Probes', this.state.response.goldSecondaryIfProbes),
                            this.renderSimpleLabel('Gold 2ºIF Probe Summary', this.state.response.goldSecondaryIfProbeSummary)))),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Could not load labels."));
    };
    LabelsModal.prototype.componentDidMount = function () {
        this.getLabels();
    };
    return LabelsModal;
}(React.PureComponent));
export { LabelsModal };
var copyButton = function (label) {
    var handler = function () {
        // navigator.clipboard isn't exposed in TS yet
        var n = navigator;
        n.clipboard.writeText(label.contentLines.join('\n'))
            .catch(function (e) {
            console.log("Could not copy: " + e);
        });
    };
    return React.createElement(Button, { icon: 'copy', label: 'Copy to clipboard', labelPosition: 'left', onClick: handler });
};
//# sourceMappingURL=LabelsModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/LabelsModal.js
// module id = 1262
// module chunks = 0